import { Component, OnInit } from '@angular/core';
import {GridPlayersManagementTypeService} from "../../services/grid-players-management-type.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {BracketItemService} from "../../services/bracket-item.service";


@Component({
  selector: 'app-set-up-grid-players-management',
  templateUrl: './set-up-grid-players-management.component.html',
  styleUrls: ['./set-up-grid-players-management.component.scss']
})
export class SetUpGridPlayersManagementComponent implements OnInit {

  private gridPlayersManagementTypes = {
    auto: 'auto',
    manual: 'manual',
  }

  constructor(
    private gridPlayersManagementType: GridPlayersManagementTypeService,
    private activeModal: NgbActiveModal,
    private bracketsService: BracketItemService
  ) { }

  ngOnInit(): void {
  }

  getTournamentIdFromUrl() {
    return +(window.location.href.match(/\/(\d+)(?=\/)/gi)[0].slice(1,));
  }

  autoClickHandler() {
    this.gridPlayersManagementType
      .setUpPlayersManagementType(this.gridPlayersManagementTypes.auto, this.getTournamentIdFromUrl())
      .subscribe(() => {
        this.closeModalAfterChoice();
        this.bracketsService.updateAll();
      });
  }

  manualClickHandler() {
    this.gridPlayersManagementType
      .setUpPlayersManagementType(this.gridPlayersManagementTypes.manual, this.getTournamentIdFromUrl())
      .subscribe(() => {
        this.closeModalAfterChoice();
      });
  }

  closeModalAfterChoice() {
    this.activeModal.close();
  }

}
